/**
 * @author SwathiDivya Bhavaraju
 * @email [example@mail.com]
 * @create date 2022-12-22 12:32:56
 * @modify date 2022-12-22 12:32:56
 * @desc [description]
 */
import axios from 'axios';

/**
 * salesTeam post API
* to add new salesTeam */
export async function addSalesTeam(data) {
    let res = {};
    await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/salesteam`, data).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('add salesTeam java api error', err); // eslint-disable-line no-console
    });
    return res;
}
/**
 * salesTeam list get API
* to get the list of salesTeams */
export async function getSalesTeamList() {
    let list = [];
    await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/salesteam`).then((response) => {
        if (response && response.data) list = response.data.data;
    }).catch((err) => {
        console.log('get salesTeam list java api error', err); // eslint-disable-line no-console
    });
    return list;
}
/**
 * salesTeam delete API
* to remove the salesTeam */
export async function removeSalesTeam(list) {
    let res = {};
    await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/salesteam`, {
        data: {
            user_ids: list,
        },
    }).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('remove salesTeam java api error', err); // eslint-disable-line no-console
    });
    return res;
}

/**
 * repPM list get API
* to get the list of repPM */
export async function getREPProjectManagerList() {
    let list = [];
    await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repprojectmanager`).then((response) => {
        if (response && response.data) list = response.data.data;
    }).catch((err) => {
        console.log('get repprojectmanager list java api error', err); // eslint-disable-line no-console
    });
    return list;
}
/**
 * repPM delete API
* to remove the repPM */
export async function removeREPProjectManager(list) {
    console.log(list);
    let res = {};
    await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repprojectmanager`, {
        data: {
            user_ids: list,
        },
    }).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('remove repprojectmanager java api error', err); // eslint-disable-line no-console
    });
    return res;
}

/**
 * repPM post API
* to add new repPM */
export async function addRepProjectManager(data) {
    let res = {};
    await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repprojectmanager`, data).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('add repprojectmanager java api error', err); // eslint-disable-line no-console
    });
    return res;
}

/* /launchpad/service/reppmtopm put API
 * to convert the rep Pm to Normal Pm */
export async function convertREPPmToPm(data) {
    let result = {};
    await axios
        .put(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/reppmtopm`, data)
        .then((response) => {
            if (response.status === 200 && response.data) {
                result = response.data;
            }
        })
        .catch((err) => {
            console.log('/launchpad/service/reppmtopm put java api error', err); // eslint-disable-line no-console
        });
    return result;
}
/* /launchpad/service/pmtoreppm put API
 * to convert the Normal Pm to REP Pm */
export async function convertPmToRepPm(data) {
    let result = {};
    await axios
        .put(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/pmtoreppm`, data)
        .then((response) => {
            if (response.status === 200 && response.data) {
                result = response.data;
            }
        })
        .catch((err) => {
            console.log('/launchpad/service/pmtoreppm put java api error', err); // eslint-disable-line no-console
        });
    return result;
}

/**
 * rep consultant post API
* to add new rep consultant */
export async function addRepConsultant(data) {
    let res = {};
    await axios.post(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repconsultant`, data).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('add repconsultant java api error', err); // eslint-disable-line no-console
    });
    return res;
}


/**
 * rep consultant list get API
* to get the list of rep consultant */
export async function getREPConsultantList() {
    let list = [];
    await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repconsultant`).then((response) => {
        if (response && response.data) list = response.data.data;
    }).catch((err) => {
        console.log('get repconsultant list java api error', err); // eslint-disable-line no-console
    });
    return list;
}
/**
 * rep consultant delete API
* to remove the rep consultant */
export async function removeREPConsultant(list) {
    console.log(list);
    let res = {};
    await axios.delete(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repconsultant`, {
        data: {
            user_ids: list,
        },
    }).then((response) => {
        res = response.data;
    }).catch((err) => {
        console.log('remove repconsultant java api error', err); // eslint-disable-line no-console
    });
    return res;
}

/* /launchpad/service/reppmtopm put API
 * to convert the rep consultant to Normal consultant */
export async function convertREPConsultantToConsultant(data) {
    let result = {};
    await axios
        .put(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/repconsultanttoconsultant`, data)
        .then((response) => {
            if (response.status === 200 && response.data) {
                result = response.data;
            }
        })
        .catch((err) => {
            console.log('/launchpad/service/repconsultanttoconsultant put java api error', err); // eslint-disable-line no-console
        });
    return result;
}
/* /launchpad/service/pmtoreppm put API
 * to convert the Normal consultant to REP Consultant */
export async function convertConsultantToRepConsultant(data) {
    let result = {};
    await axios
        .put(`${process.env.VUE_APP_JAVA_API_URL}/launchpad/service/consultanttorepconsultant`, data)
        .then((response) => {
            if (response.status === 200 && response.data) {
                result = response.data;
            }
        })
        .catch((err) => {
            console.log('/launchpad/service/pmtoreppm put java api error', err); // eslint-disable-line no-console
        });
    return result;
}